import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { dehydrate, QueryClient } from '@tanstack/react-query';

import g from 'src/constants/urls';
import { IArticleByGroupDetail } from 'src/interface/ArticleByGroup';
import { ICategoryByGroupDetail } from 'src/interface/CategoryByGroup';
import wrapper from 'src/redux';

const HeadC = dynamic(() => import('src/components/Head'));
const AuthorPage = dynamic(() => import('src/containers/Author/index'));

const DownloadContainer = dynamic(() => import('src/containers/Download'));
const BreadCrumbJsonLd = dynamic(() => import('src/components/Layout/JsonLd/Breadcrumb'));
const AuthorJsonLdC = dynamic(() => import('src/components/Layout/JsonLd/Author'));

const AuthorPages = (props: any) => {
	const event = props.event;
	const metaTitle = `Profile ${event.name} - Hallobumil`;
	const metaDescription = `Baca artikel terbaru dari ${event.name} di Hallobumil. Temukan informasi mengenai pra kehamilan, kehamilan. pasca kehamilan dan informasi kehamilan lainnya.`;
	return (
		<>
			<HeadC title={metaTitle} description={metaDescription} pageItem={event} />
			<AuthorPage {...props} />
			<DownloadContainer />
			<AuthorJsonLdC article={event} />
			<BreadCrumbJsonLd pageHeaderContent={props.pageHeaderContent} />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (ctx: any) => {
		let isError: boolean = false;
		let event: any = {};
		const queryClient = new QueryClient();
		const query = ctx.params;
		const subCategorySlug = query.sub;
		let artikelAuthor: any = [];
		const uppercaseCount = (subCategorySlug.match(/[A-Z]/g) || []).length;

		try {
			const urievent = `${g.API_ARTICLE_SLUG}/author/slug/${subCategorySlug.toLowerCase()}`;
			const optsEvent = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};
			const eventList = await fetch(urievent, optsEvent);
			event = await eventList.json().then((res) => ({ ...res, status: eventList.status }));

			if (uppercaseCount >= 1) {
				return {
					redirect: {
						destination: `/author/${subCategorySlug.toLowerCase()}`,
						statusCode: 301,
					},
				};
			}

			const uriAuthor = `${g.API_ARTICLE_SLUG}/articles/author/${subCategorySlug}?order=desc&orderby=publish_date&per_page=10&page=1`;
			const optsAuthor = {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			};

			const s3 = await fetch(uriAuthor, optsAuthor);
			artikelAuthor = await s3.json().then((res) => ({ ...res, status: s3.status }));

		} catch (err: any) {
			if (err?.status === 400) {
				isError = true;
			} else {
				throw err;
			}
		}
		const subCategories: ICategoryByGroupDetail[] = store.getState().categoryByGroup.subCategories;
		const category = subCategories.find(
			(sc) => sc.slug === subCategorySlug,
		) as ICategoryByGroupDetail;

		const article: IArticleByGroupDetail[] =
			store.getState().articleByGroup.articleByCategory?.data?.records;

		if ((!category || !article) && isError) return { notFound: true };
		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				card: true,
				isWhiteBackground: false,
				JsonLd: {
					organization: true,
					breadcrumbs: true,
				},
				pageHeaderContent: {
					title: 'author',
					breadcrumbs: [
						{ label: 'Beranda', navigatePath: '/' },
						{ label: event.data.record.title },
					],
				},
				event: event.data.record || {},
				artikel: artikelAuthor.data.records || [],
				bc: [
					{ path: '/', breadcrumbName: 'Beranda' },
					{ breadcrumbName: event.data.record.name },
				],
			},
		};
	},
);

export default AuthorPages;
